import { API } from './instances'

const DUTIES_URL = '/Aranceles'
const inFlightDutiesRequests = new Map()

const buildDutiesRequestKey = (url, data = {}) => {
    const normalizedEntries = Object.entries(data)
        .filter(([, value]) => value !== undefined && value !== null)
        .sort(([a], [b]) => a.localeCompare(b))

    const query = new URLSearchParams(normalizedEntries).toString()
    return query ? `${url}?${query}` : url
}

export const getDuties = async data => {
    const requestKey = buildDutiesRequestKey(DUTIES_URL, data)

    if (inFlightDutiesRequests.has(requestKey)) {
        return inFlightDutiesRequests.get(requestKey)
    }

    const requestPromise = API.get(DUTIES_URL, { params: data }).finally(() => {
        if (inFlightDutiesRequests.get(requestKey) === requestPromise) {
            inFlightDutiesRequests.delete(requestKey)
        }
    })

    inFlightDutiesRequests.set(requestKey, requestPromise)
    return requestPromise
}

export const downloadDutiesAsFile = async (data, extension) => {
    const url = `/Aranceles/exportar/${extension}/${data.id}`
    return await API.get(url, { responseType: 'arraybuffer' })
}